<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <form class="form-horizontal mt-3">
        <div class="row">
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-6">
                <div class="row form-group">
                  <label
                    class="col-md-3 col-form-label"
                    :class="{
                      required: model.is_student
                    }"
                  >
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.batch'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="number"
                      v-model.number="model.promotion"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          errors.has('promotion') || $v.model.promotion.$error
                      }"
                    />
                    <span
                      class="invalid-feedback"
                      v-if="batchErrors.length > 0"
                      >{{ batchErrors[0] }}</span
                    >
                    <div
                      v-if="errors.has('promotion')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('promotion') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label
                    class="col-md-3 col-form-label"
                    :class="{
                      required: model.is_student
                    }"
                  >
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.department'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <select
                      class="form-control"
                      v-model="model.acp_id"
                      @change="onMainProgramChange(model.acp_id)"
                      :class="{
                        'is-invalid':
                          errors.has('acp_id') || $v.model.acp_id.$error
                      }"
                    >
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(main, index) in main_programs"
                        :key="index"
                        :value="main.acp_id"
                        >{{ main.acp_name_foreign }}</option
                      >
                    </select>
                    <span
                      class="invalid-feedback"
                      v-if="acpIdErrors.length > 0"
                      >{{ acpIdErrors[0] }}</span
                    >
                    <div v-if="errors.has('acp_id')" class="invalid-feedback">
                      {{ errors.first('acp_id') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label
                    class="col-md-3 col-form-label"
                    :class="{
                      required: model.is_student
                    }"
                  >
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.major'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-loading-banner :loading="fetch_sub">
                      <select
                        v-model="model.acps_id"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            errors.has('acps_id') || $v.model.acps_id.$error
                        }"
                        @change="fetchLevel(model.acps_id)"
                      >
                        <option :value="null">{{ $t('select') }}</option>
                        <option
                          v-for="(sub, index) in sub_programs"
                          :key="index"
                          :value="sub.acps_id"
                        >
                          {{ sub.acps_name_foreign }}
                        </option>
                      </select>
                    </ts-loading-banner>
                    <span
                      class="invalid-feedback"
                      v-if="acpsIdErrors.length > 0"
                      >{{ acpsIdErrors[0] }}</span
                    >
                    <div class="invalid-feedback" v-if="errors.has('acps_id')">
                      {{ errors.first('acps_id') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label
                    class="col-md-3 col-form-label"
                    :class="{
                      required: model.is_student
                    }"
                  >
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.degree'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-loading-banner :loading="level_fetch">
                      <a-select
                        v-model="model.level_id"
                        mode="multiple"
                        :options="
                          levels.map(el => ({
                            value: el.level_id,
                            label: el.level_name_foreign
                          }))
                        "
                        class="ts-w-full"
                      ></a-select>
                    </ts-loading-banner>
                    <div class="validate" v-if="errors.has('level_id')">
                      {{ errors.first('level_id') }}
                    </div>
                    <span class="validate" v-if="levelIdErrors.length > 0">{{
                      levelIdErrors[0]
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.fromSchool'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model.trim="model.changed_in_from_school"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has('changed_in_from_school')
                      }"
                    />
                    <div
                      v-if="errors.has('changed_in_from_school')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('changed_in_from_school') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.fromSchoolType'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-search-select
                      v-model.number="model.changed_in_from_school_type"
                      :options="itemListOptions"
                    ></ts-search-select>
                    <div
                      v-if="errors.has('changed_in_from_school_type')"
                      class="validate"
                    >
                      {{ errors.first('changed_in_from_school_type') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.anotherProgram'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model.trim="model.current_school_another_program"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has(
                          'current_school_another_program'
                        )
                      }"
                    />
                    <small>
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.atAnotherSchool'
                        )
                      }}
                    </small>
                    <div
                      v-if="errors.has('current_school_another_program')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('current_school_another_program') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-12">
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.schoolType'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-search-select
                      v-model.number="model.current_school_another_program_type"
                      :options="itemListOptions"
                    ></ts-search-select>
                    <div
                      v-if="errors.has('current_school_another_program_type')"
                      class="validate"
                    >
                      {{ errors.first('current_school_another_program_type') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.studyTime'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-search-select
                      v-model.number="model.ac_st_id"
                      :options="studyTimesOptions"
                    ></ts-search-select>
                    <div v-if="errors.has('ac_st_id')" class="validate">
                      {{ errors.first('ac_st_id') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <fieldset>
              <legend class="text-black">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.academicStudentStatus'
                  )
                }}
              </legend>
              <div class="overflow-auto">
                <table
                  class="table ui-table table-hover"
                  id="student-status-table"
                >
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.year'
                          )
                        }}
                      </th>
                      <th class="ts-whitespace-no-wrap text-center">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.semester'
                          )
                        }}
                      </th>
                      <th class="ts-whitespace-no-wrap text-center">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.academicYear'
                          )
                        }}
                      </th>
                      <th class="ts-whitespace-no-wrap text-center">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.major'
                          )
                        }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width:3%"
                      >
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.academicStatus'
                          )
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in model.student_current_status"
                      :key="index"
                    >
                      <td>
                        <ts-select
                          v-model="item.academic_year"
                          class="form-control"
                          :options="academicYearOptions"
                        />
                      </td>
                      <td>
                        <ts-select
                          v-model="item.academic_semester"
                          class="form-control"
                          :options="academicSemesterOptions"
                        />
                      </td>
                      <td>
                        <ts-select
                          v-model="item.ac_year_id"
                          class="form-control"
                          :options="acYearOptions"
                        />
                      </td>
                      <td>
                        <ts-select
                          v-model="item.acps_id"
                          class="form-control"
                          :options="majorOptions"
                          disabled
                        />
                      </td>
                      <td>
                        <ts-input
                          v-model="item.ac_status"
                          class="form-control ts-text-center"
                          readonly
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
          </div>
          <div class="col-md-2"></div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'school-information-form',
  props: ['value', 'validate', 'clear'],
  data () {
    return {
      model: {},
      loadingPreData: false,
      fetch_sub: false,
      sub_programs: [],
      level_fetch: false,
      levels: [],
      errors: new Errors()
    }
  },
  validations: {
    model: {
      promotion: { required },
      acp_id: { required },
      acps_id: { required },
      level_id: { required }
    },
    form: ['model.promotion', 'model.acp_id', 'model.acps_id', 'model.level_id']
  },
  created () {
    this.model = this.value
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('studentProfile', [
      'itemLists',
      'studyTimes',
      'edit_data',
      'main_programs'
    ]),
    batchErrors () {
      const errors = []
      if (!this.$v.model.promotion.$error) return errors
      !this.$v.model.promotion.required && errors.push('Required')
      return errors
    },
    acpIdErrors () {
      const errors = []
      if (!this.$v.model.acp_id.$error) return errors
      !this.$v.model.acp_id.required && errors.push('Required')
      return errors
    },
    acpsIdErrors () {
      const errors = []
      if (!this.$v.model.acps_id.$error) return errors
      !this.$v.model.acps_id.required && errors.push('Required')
      return errors
    },
    levelIdErrors () {
      const errors = []
      if (!this.$v.model.level_id.$error) return errors
      !this.$v.model.level_id.required && errors.push('Required')
      return errors
    },
    acYearOptions () {
      return this.$store.state.studentProfile.ac_years.map(el => ({
        value: el.ac_year_id,
        text: el.ac_year
      }))
    },
    majorOptions () {
      return this.$store.state.studentProfile.sub_programs.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    },
    academicYearOptions () {
      return this.$store.state.studentProfile.academic_years.map(year => ({
        value: year,
        text: year
      }))
    },
    academicSemesterOptions () {
      return this.$store.state.studentProfile.academic_terms.map(semester => ({
        value: semester,
        text: semester
      }))
    },
    studyTimesOptions () {
      return this.studyTimes.map(el => ({
        value: el.ac_st_id,
        text: el.session + '|' + el.study_time
      }))
    },
    itemListOptions () {
      return this.itemLists.map(el => ({
        value: el.item_list_id,
        text: el.description
      }))
    }
  },
  methods: {
    ...mapActions('studentProfile', [
      'fetchStudyTime',
      'getMainProgram',
      'getSubProgram',
      'getYear'
    ]),
    validateForm () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      return isValid
    },
    async fetchResourceBeforeCreate () {
      this.loadingPreData = true
      await Promise.all([
        this.fetchStudyTime(),
        this.getMainProgram(),
        this.getSubProgram(),
        this.getYear()
      ]).then(() => {})
      await this.$store
        .dispatch('studentProfile/dataForSchoolInformation')
        .then(() => {
          this.model = this.value
          this.setEditData()
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    onMainProgramChange (acp_id) {
      this.model.acps_id = null
      this.sub_programs = []
      this.model.level_id = []
      this.levels = []
      this.fetch_sub = true
      this.$store
        .dispatch('studentProfile/getSubProgramByMain', { acp_id: acp_id })
        .then(response => {
          this.fetch_sub = false
          this.sub_programs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_sub = false
        })
    },
    fetchLevel (acps_id) {
      this.model.level = null
      this.levels = []
      if (acps_id) {
        this.level_fetch = true
        this.$store
          .dispatch('studentProfile/getLevel', { acps_id: acps_id })
          .then(response => {
            this.levels = response.data
          })
          .finally(() => {
            this.level_fetch = false
          })
      }
    },
    async setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        await this.onMainProgramChange(this.edit_data.acp_id)
        await this.fetchLevel(this.edit_data.acps_id)
        ;(this.model.student_id = this.edit_data.student_id),
          (this.model.changed_in_from_school = this.edit_data.changed_in_from_school),
          (this.model.changed_in_from_school_type = this.edit_data.changed_in_from_school_type),
          (this.model.current_school_another_program = this.edit_data.current_school_another_program),
          (this.model.current_school_another_program_type = this.edit_data.current_school_another_program_type),
          (this.model.ac_st_id = this.edit_data.ac_st_id),
          (this.model.promotion = this.edit_data.promotion),
          (this.model.acp_id = this.edit_data.acp_id),
          (this.model.acps_id = this.edit_data.acps_id)
        this.model.place_of_birth_kh = this.edit_data.place_of_birth_kh
        this.model.student_current_status = []
        this.model.level_id = []
        if (this.edit_data.level_id) {
          this.edit_data.level_id.split(',').map(el => {
            this.model.level_id.push(parseInt(el))
          })
        }

        _.orderBy(
          this.edit_data.student_current_status,
          ['academic_year'],
          ['asc']
        ).map(scs => {
          this.model.student_current_status.push({
            academic_year: scs.academic_year,
            academic_semester: scs.academic_semester,
            acps_id: scs.acps_id,
            ac_year_id: scs.ac_year_id,
            ac_status: scs.ac_status_description
          })
        })
      }
    }
  },
  watch: {
    validate: {
      handler () {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    clear: function (value) {
      if (value == true) {
        this.model = this.value
      }
    }
  }
}
</script>
<style lang="css" scoped>
#student-status-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 9; */
  padding: 7px;
  border-bottom: none !important;
}

#student-status-table > tbody > tr > td {
  cursor: pointer;
  padding: 0;
}
</style>
